import { Utils } from "./utils";

export class reviewForm {
    public allUploadedMedia;
    public imageUploadOpenFlag;
    public addPhotoListener;
    public backImageUploadState;
    public editImageUploadState;
    public editBeforeCancelOrUploadFlag;
    public fileObjectOnChangeAction;
    public editImageHandleEventListener;
    public updateImagehandleListener;
    public changeImageAndBackFlag;
    public onFocusEventHandleListener;
    constructor() {
        this.backImageUploadState = false;
        this.editImageUploadState = false;
        this.changeImageAndBackFlag = false;
    }
    

    // adding Tab and shift tab listener for browse image icon
    tabListenerForBrowseImageButton = (element) => {
        const $krInputBrowseImage = element.querySelector('.kr-input-upload-photos');
        let activeElement = element.querySelector('.kr-inline-form-active');
        const handleListener = (event) => {
            if (event.shiftKey && event.key == 'Tab') {
                event.preventDefault();
                const $krUploadedThumbnails = element.querySelectorAll('.kr-uploaded-thumbnails');
                let $krUploadedThumbnailsLength = $krUploadedThumbnails.length;
                if($krUploadedThumbnailsLength>0) {
                    ($krUploadedThumbnails[$krUploadedThumbnailsLength-1] as HTMLElement).focus();
                } else {
                    //activeElement.querySelector('.kr-inline-review-button').focus();
                }
            }else if (event.key === 'Tab'){
                event.preventDefault();
                activeElement.querySelector('.kr-inline-review-button').focus();
            }
        };
        $krInputBrowseImage.addEventListener('keydown', handleListener);
    }
    
    addMediaUploadListener = (selector, element) => {
        let self= this;
        const inputElement = element.querySelectorAll(selector);
        inputElement.forEach(item => {
            let dropZoneElement = item.closest(".drop-zone");
            dropZoneElement.addEventListener("click", () => {
                (item as HTMLInputElement).click();
            });
            item.addEventListener("click", (event) => {
                event.target.value = '';
            });
            item.addEventListener("change", () => {
                if ((item as HTMLInputElement).files.length) {
                    let selectedImage = element.querySelector('.kr-upload-thumbnail');
                    if (selectedImage.querySelector('.drop-zone__thumb')){
                        selectedImage.querySelector('.drop-zone__thumb').remove();
                        selectedImage.querySelector('.kr-noimage-text').classList.add('kr-hide');
                    }
                    self.updateThumbnail(dropZoneElement, (item as HTMLInputElement).files[0], element);

                }
            });

            dropZoneElement.addEventListener("dragover", (e) => {
                e.preventDefault();
                dropZoneElement.classList.add("drop-zone--over");
            });

            ["dragleave", "dragend"].forEach((type) => {
                dropZoneElement.addEventListener(type, () => {
                    dropZoneElement.classList.remove("drop-zone--over");
                });
            });

            dropZoneElement.addEventListener("drop", (e) => {
                e.preventDefault();

                if ((e as DragEvent).dataTransfer.files.length) {
                    (inputElement as HTMLInputElement).files = (e as DragEvent).dataTransfer.files;
                    self.updateThumbnail(dropZoneElement, (e as DragEvent).dataTransfer.files[0], element);
                }

                dropZoneElement.classList.remove("drop-zone--over");
            });
        });
    }

    /**
     * Updates the thumbnail on a drop zone element.
     *
     * @param {HTMLElement} dropZoneElement
     * @param {File} file
     */
    updateThumbnail = (dropZoneElement, file, newElement, changeImageFlag=false) => {
        let self = this;
        let element = newElement.querySelector('.kr-inline-form-active') as HTMLLIElement;
        let thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb"),
            //writeReviewHeadingWrapperSelector = element.querySelector('.kr-writeReview-heading-wrapper'),
            //uploadImageHeaderSelector = element.querySelector('.kr-upload-image-header'),
            uploadImageWrapper = element.querySelector('.kr-image-upload-wrapper') as HTMLLIElement,
            $imageCaptionSection = (element.querySelector('.kr-image-caption-section') as HTMLInputElement),
            $infoText = $imageCaptionSection.querySelector('.kr-info-text'),
            captionPhotoElement = dropZoneElement.querySelector(".drop-zone__thumb"),
            onlyImageChange = false;
        if(!file.type.includes('image')) {
            element.querySelector('#kr-uploadImageTypeError-error').classList.remove('kr-hide');
            if(changeImageFlag) {
                element.querySelector('#kr-uploadChangeImageTypeError-error').classList.remove('kr-hide');
            } else {
                element.querySelector('#kr-uploadImageTypeError-error').classList.remove('kr-hide');
            }
        } else {
            // First time - there is no thumbnail element, so lets create it
            if (!thumbnailElement) {
                thumbnailElement = document.createElement("div");
                captionPhotoElement = document.createElement("div");
                $infoText.classList.remove('kr-error-holder');
                $imageCaptionSection.querySelector('span').innerHTML = String(90);
                thumbnailElement.classList.add("drop-zone__thumb");
                captionPhotoElement.classList.add("drop-zone__thumb");
                if(element.querySelector('.kr-upload-thumbnail').hasChildNodes() && element.querySelector('.kr-upload-thumbnail .drop-zone__thumb')) {
                    element.querySelector('.kr-upload-thumbnail .drop-zone__thumb').remove();
                }
                element.querySelector('.kr-upload-thumbnail').appendChild(captionPhotoElement);
                self.showImageUploadForm(element);
                let imageSection=element.querySelector('.kr-images-section');
                let addButtonSelector = ".kr-add-photo-button-" + (imageSection.childNodes.length).toString();
                if(changeImageFlag) {
                    element.querySelector('#kr-uploadChangeImageTypeError-error').classList.add('kr-hide');
                    onlyImageChange = true;
                } else {
                    element.querySelector('#kr-uploadImageTypeError-error').classList.add('kr-hide');
                    element.querySelector('#kr-add-photo-button').setAttribute('class', "");
                    element.querySelector('#kr-add-photo-button').classList.add("kr-add-photo-button-" + (imageSection.childNodes.length).toString());
                }
                //writeReviewHeadingWrapperSelector.classList.add('kr-hide');
                uploadImageWrapper.classList.remove('kr-hide');
                (element.querySelector('.kr-back-to-formButton') as HTMLAnchorElement).focus();
                //Listener added when clicked on add Photo button
                reviewForm.prototype.addPhotoListener = async ()=> {
                    let uploadThumbnailImage = document.createElement("div"),
                        iconTickElement = document.createElement("div"),
                        imageSection=element.querySelector('.kr-images-section'),
                        randomStr = Utils.randomStr(20, '12345abcde'),
                        svgContent = element.querySelector(".kr-item-checked-icon").innerHTML,
                        captionText = element.querySelector("#kr-imageCaption") as HTMLInputElement;
                    uploadThumbnailImage.classList.add('kr-uploaded-thumbnails');
                    iconTickElement.classList.add('kr-checked-icon-svg');
                    iconTickElement.innerHTML = svgContent;
                    uploadThumbnailImage.setAttribute('data-image-index', (imageSection.childNodes.length-1).toString());
                    uploadThumbnailImage.classList.add('kr-tn-image-'+(imageSection.childNodes.length).toString()+'_'+randomStr);
                    if(imageSection.childNodes.length<=7) {
                        uploadThumbnailImage.setAttribute('tabindex', '0');
                        uploadThumbnailImage.setAttribute('role', 'img');
                        let textCaption = captionText.value.length ? captionText.value: "Image "+(imageSection.childNodes.length-1).toString()
                        uploadThumbnailImage.setAttribute('aria-label', textCaption);
                        // added thumbnail image to the div created for selected element
                        uploadThumbnailImage.appendChild(thumbnailElement);
                        uploadThumbnailImage.appendChild(iconTickElement);
                        // added class for caption text to caption p tag
                        if(!reviewForm.prototype.allUploadedMedia) {
                            reviewForm.prototype.allUploadedMedia = [];
                        }
                        reviewForm.prototype.allUploadedMedia.push({
                            file:file,
                            caption: captionText.value
                        });
                        let dropZoneElem = element.querySelector('.kr-images-section .drop-zone');
                        self.appendEventCaptionContainer(captionText.value, element);
                        captionText.value="";
                        await imageSection.insertBefore(uploadThumbnailImage, dropZoneElem);
                    }
                    self.hideImageUploadForm(element);
                    if(element.querySelector('.kr-images-section').childNodes.length>=7) {
                        self.hideInputIfMaxNumberImageUploaded(element);
                    }
                    const imageSectionSelector = element.querySelectorAll('.kr-uploaded-thumbnails');
                    if(imageSectionSelector.length>0) {
                        (imageSectionSelector[0] as HTMLElement).focus();
                    }
                    await self.onFocusEventListenerThumbnailImage(imageSection.childNodes.length-2, element);
                    self.moveFocusToButtonFromImage(imageSection.childNodes.length-2, element);
                    self.moveFocusFromDeleteButtonToImage(imageSection.childNodes.length-2, element);
                    self.backImageUploadState = false;
                    self.changeImageAndBackFlag = false;
                }
                if(self.editImageUploadState) {
                    self.backImageUploadState = false;
                    self.editImageUploadState= false;
                }
                // adding listener only when event is not coming from changeImage/back/cancel
                if(self.changeImageAndBackFlag&&self.editBeforeCancelOrUploadFlag){
                    changeImageFlag=false
                    self.changeImageAndBackFlag=false;
                    self.editBeforeCancelOrUploadFlag=false
                }
                if(self.changeImageAndBackFlag){
                    changeImageFlag=true
                    self.changeImageAndBackFlag=false;
                }
                if(!changeImageFlag && !self.backImageUploadState) {
                    self.addPhotoToThumbnailView(addButtonSelector, element);
                    (element.querySelector('.kr-image-caption-section textarea') as HTMLTextAreaElement).value="";
                }
                if(!reviewForm.prototype.imageUploadOpenFlag) {
                    reviewForm.prototype.imageUploadOpenFlag = true;
                    self.changeImageAction(element, newElement);
                    self.backToFormButton(element);
                }
                self.updateImageCaptionValue(onlyImageChange, element);
            }
            // thumbnailElement.dataset.label = file.name;

            // Show thumbnail for image files
            if (file.type.startsWith("image/")) {
                const reader = new FileReader();

                reader.readAsDataURL(file);
                reader.onload = () => {
                    thumbnailElement.style.backgroundImage = `url('${reader.result}')`;
                    captionPhotoElement.style.backgroundImage = `url('${reader.result}')`;
                };
            } else {
                thumbnailElement.style.backgroundImage = null;
                captionPhotoElement.style.backgroundImage = null;
            }

        }

    }

    updateImageCaptionValue(onlyImageChange=false, element): void{
        let self = this;
        let $imageCaptionTxt = (element.querySelector('#kr-imageCaption') as HTMLInputElement),
            $imageCaptionSection = (element.querySelector('.kr-image-caption-section') as HTMLInputElement),
            $infoText = $imageCaptionSection.querySelector('.kr-info-text'),
            $addPhotoButton = element.querySelector('#kr-add-photo-button'),
            $updatePhotoButton = element.querySelector('#kr-update-photo-button');
        if ($imageCaptionTxt) {
            const handleListener = (ev)=>{
                let len = 0,
                    onlySpace = false;
                if(onlyImageChange){
                    $imageCaptionTxt = (element.querySelector('#kr-imageCaption') as HTMLInputElement);
                }
                if (self.onlySpaces($imageCaptionTxt.value)) {
                    onlySpace=true
                }
                len = $imageCaptionTxt.value.length
                if(ev.clipboardData){
                    const text = (ev.originalEvent || ev).clipboardData.getData('text/plain');
                    len = len + text.length
                    onlySpace=false
                }
                $imageCaptionSection.querySelector('span').innerHTML = (90 - parseInt(String(len))).toString();
                if(len) {
                    if(len>90 || (len < 90 && onlySpace)) {
                        $infoText.classList.add('kr-error-holder');
                        $addPhotoButton.setAttribute('disabled', 'true');
                        if($updatePhotoButton) {
                            $updatePhotoButton.setAttribute('disabled', 'true');
                        }
                    } else if($infoText.classList.contains('kr-error-holder')) {
                        $infoText.classList.remove('kr-error-holder');
                        $addPhotoButton.removeAttribute('disabled');
                        if($updatePhotoButton) {
                            $updatePhotoButton.removeAttribute('disabled');
                        }
                    }
                } else {
                    $infoText.classList.remove('kr-error-holder');
                    $addPhotoButton.removeAttribute('disabled');
                    if($updatePhotoButton) {
                        $updatePhotoButton.removeAttribute('disabled');
                    }
                }
            }
            if(onlyImageChange){
                handleListener(Event);
            }else {
                $imageCaptionTxt.addEventListener('keyup', handleListener);
                $imageCaptionTxt.addEventListener('paste', handleListener);
            }
        }
    }
    //onFocus EventListener for thumbnail image
    onFocusEventListenerThumbnailImage = async (indexValue, element)=> {
        const imageSectionSelector = element.querySelectorAll('.kr-uploaded-thumbnails')[indexValue],
            self = this;
        reviewForm.prototype.onFocusEventHandleListener = () => {
            let captionText = reviewForm.prototype.allUploadedMedia[indexValue] && reviewForm.prototype.allUploadedMedia[indexValue].hasOwnProperty('caption') ?
                reviewForm.prototype.allUploadedMedia[indexValue]['caption']: "";
            self.appendEventCaptionContainer(captionText, element, indexValue);
        };
        if(imageSectionSelector) {
            imageSectionSelector.removeEventListener('focus', reviewForm.prototype.onFocusEventHandleListener);
            imageSectionSelector.addEventListener('focus', reviewForm.prototype.onFocusEventHandleListener);
        }
    }

    // Caption and event listener added when image is uploaded.
    appendEventCaptionContainer = async (captionText, element, indexValue=0)=>{
        const imageCaptionEventsSelector = element.querySelector('.kr-image-caption-events-container'),
            imageUploadEvent = element.querySelector('.kr-image-upload-events'),
            imageUploadEventDivElement = document.createElement("div"),
            imageUploadEventsContainerSelector = element.querySelector('.kr-image-upload-events-container'),
            noCaptionText = element.querySelector('.kr-noCaption-content').textContent,
            self = this;
        imageUploadEventDivElement.classList.add('kr-image-upload-events-container');
        if(reviewForm.prototype.allUploadedMedia[indexValue].hasOwnProperty('caption') && reviewForm.prototype.allUploadedMedia[indexValue]['caption']) {
            imageCaptionEventsSelector.querySelector('.kr-image-caption-text').innerHTML = reviewForm.prototype.allUploadedMedia[indexValue]['caption'];
        }else {
           imageCaptionEventsSelector.querySelector('.kr-image-caption-text').textContent = noCaptionText; 
        }
        imageUploadEventDivElement.innerHTML = imageUploadEvent.innerHTML;
        if(imageUploadEventsContainerSelector) {
            imageUploadEventsContainerSelector.remove();
        }
        imageCaptionEventsSelector.appendChild(imageUploadEventDivElement);
        imageCaptionEventsSelector.classList.remove('kr-hide');
        imageCaptionEventsSelector.querySelector('.kr-edit-image').setAttribute('data-image-index', indexValue.toString());
        imageCaptionEventsSelector.querySelector('.kr-remove-image').setAttribute('data-image-index', indexValue.toString());
        self.removeImageFromThumbnailView('.kr-image-upload-events-container .kr-remove-image', indexValue, element);
        self.editImageFromThumbnailView('.kr-image-upload-events-container .kr-edit-image', indexValue, element);
        self.moveFocusFromDeleteButtonToImage(indexValue, element);
    }

    // Accessibility: Move focus to button from Image when tab pressed
    moveFocusToButtonFromImage = (index, element) =>{
        const imageSectionSelectors = element.querySelectorAll('.kr-uploaded-thumbnails'),
            imageCaptionEventsSelector = element.querySelector('.kr-image-caption-events-container');
        if (imageSectionSelectors[index]) {
            let handleListener = (event) =>{
                if (event.shiftKey && event.key == 'Tab') {
                    event.preventDefault();
                    if(index>=0){
                        (imageSectionSelectors[index-1] as HTMLElement).focus();
                    }
                }else if (event.key === 'Tab'){
                    event.preventDefault();
                    const captionLabelSelector = imageCaptionEventsSelector.querySelector('.kr-label');
                    if(!captionLabelSelector.classList.contains('isInactive')) {
                        captionLabelSelector.setAttribute('tabindex', '0');
                        (captionLabelSelector as HTMLElement).focus();
                    } else {
                        (imageCaptionEventsSelector.querySelector('.kr-edit-image') as HTMLInputElement).focus();
                    }
                }
            }
            imageSectionSelectors[index].addEventListener('keydown', handleListener);
        }
    }

    // Accessibility: Move focus from button to Image when tab pressed
    moveFocusFromDeleteButtonToImage = (index, element) =>{
        const deleteEventSelector = element.querySelector('.kr-image-caption-events-container .kr-remove-image');
        if (deleteEventSelector) {
            let handleListener = (event) =>{
                if (event.key === 'Tab'){
                    event.preventDefault();
                    let dataImageIndex = deleteEventSelector.getAttribute('data-image-index'),
                        allImageElements = element.querySelectorAll('.kr-uploaded-thumbnails');
                    if(allImageElements.length-1 > parseInt(dataImageIndex)) {
                        (allImageElements[parseInt(dataImageIndex)+1] as HTMLElement).focus();
                    } else if(allImageElements.length>=6) {
                        (element.querySelector('#kr-nckName') as HTMLInputElement).focus();
                    } else {
                        (element.querySelector('.kr-input-upload-photos') as HTMLAnchorElement).focus();
                    }
                }
            }
            deleteEventSelector.addEventListener('keydown', handleListener);
        }
    }

    addPhotoToThumbnailView = (addButtonSelector, element) => {
        let addPhotoButton = element.querySelector(addButtonSelector);
        addPhotoButton.removeEventListener('click', ()=>{
            reviewForm.prototype.addPhotoListener();
        });
        addPhotoButton.addEventListener('click', ()=>{
            reviewForm.prototype.addPhotoListener();
        }, {once: true});
    }

    hideInputIfMaxNumberImageUploaded = (element) => {
        element.querySelector('.drop-zone').classList.add("kr-hide");
    }

    showInputIfNotMaxNumberImageUploaded = (element) => {
        element.querySelector('.drop-zone').classList.remove("kr-hide");
    }


    showImageUploadForm = (element) => {
        let uploadImageWrapper = element.querySelector('.kr-image-upload-wrapper') as HTMLLIElement;
        uploadImageWrapper.classList.remove('kr-hide');
    }

    hideImageUploadForm = (element) => {
        let self = this;
        if (element.querySelector('.kr-image-upload-wrapper')) {
            let uploadImageWrapper = element.querySelector('.kr-image-upload-wrapper') as HTMLLIElement;
            uploadImageWrapper.classList.add('kr-hide');
            element.querySelector('.kr-noimage-text').classList.add('kr-hide');
            element.querySelector('#kr-add-photo-button').removeAttribute('disabled');
            element.querySelector('#kr-uploadChangeImageTypeError-error').classList.add('kr-hide');
            element.querySelector('#kr-uploadImageTypeError-error').classList.add('kr-hide');
            //writeReviewHeadingWrapperSelector.classList.remove('kr-hide');
            element.querySelector('.kr-edit-upload-image-heading').classList.add('kr-hide');
            element.querySelector('.kr-upload-image-heading').classList.remove('kr-hide');
            element.querySelector('#kr-update-photo-button').classList.add('kr-hide');
            (element.querySelector('.kr-image-caption-section textarea') as HTMLTextAreaElement).value = "";
            if (element.querySelectorAll('.kr-uploaded-thumbnails')) {
                let uploadImageThumbnailSelector = element.querySelectorAll('.kr-uploaded-thumbnails');
                if (uploadImageThumbnailSelector.length) (uploadImageThumbnailSelector[0] as HTMLElement).focus();
            } else {
                element.querySelector('.kr-input-upload-photos').focus();
            }
            self.backImageUploadState = true;    //TODO:to check scenario
            self.fileObjectOnChangeAction = undefined;
            if (self.editBeforeCancelOrUploadFlag && !self.editImageUploadState) {
                self.backImageUploadState = false
                if (self.changeImageAndBackFlag) {
                    self.editBeforeCancelOrUploadFlag = true
                } else {
                    self.editBeforeCancelOrUploadFlag = false
                }
            }
            if (self.changeImageAndBackFlag) {
                self.backImageUploadState = false
            }
        }
    }

    changeImageAction = (element, newElement) => {
        let self= this;
        let changeImageSelector = element.querySelector('#kr-change-photo');
        const inputElement= element.querySelector('.drop-zone__input');
        const dropZoneElement = inputElement.closest(".drop-zone");
        let handleEventListener = () => {
            if ((changeImageSelector as HTMLInputElement).files.length) {
                let selectedImage = element.querySelector('.kr-upload-thumbnail');
                selectedImage.querySelector('.kr-noimage-text').classList.add('kr-hide');
                element.querySelector('#kr-add-photo-button').removeAttribute('disabled');
                if (selectedImage.querySelector('.drop-zone__thumb')){
                    selectedImage.querySelector('.drop-zone__thumb').remove();
                    selectedImage.querySelector('.kr-noimage-text').classList.add('kr-hide');
                }
                self.fileObjectOnChangeAction = (changeImageSelector as HTMLInputElement).files[0];
                self.updateThumbnail(dropZoneElement, (changeImageSelector as HTMLInputElement).files[0], newElement, true);
                self.changeImageAndBackFlag=true;
            }
        };
        changeImageSelector.removeEventListener('change', handleEventListener);
        changeImageSelector.addEventListener('change', handleEventListener);
        changeImageSelector.addEventListener("click", (event) => {
            (event.target as HTMLInputElement).value = '';
        });
    }

    backToFormButton = (element) => {
        let backFromImageUploadToForm = element.querySelector('.kr-back-to-formButton'),
            cancelFromImageUploadToForm = element.querySelector('#kr-cancel-photo-button');
        backFromImageUploadToForm.removeEventListener('click', this.hideImageUploadForm);
        backFromImageUploadToForm.addEventListener('click', this.hideImageUploadForm);
        cancelFromImageUploadToForm.removeEventListener('click', this.hideImageUploadForm);
        cancelFromImageUploadToForm.addEventListener('click', this.hideImageUploadForm);
        let handleBackButtonListener = (event) =>{
            if (event.key == 'Tab') {
                event.preventDefault();
                (backFromImageUploadToForm as HTMLElement).focus();
            }
        }
        if(cancelFromImageUploadToForm) {
            cancelFromImageUploadToForm.addEventListener('keydown', handleBackButtonListener);
        }
    }

    onRemoveThumbnailUpdateListener = (indexVal, element) => {
        const $krUploadedThumbnails = element.querySelectorAll('.kr-uploaded-thumbnails');
        for (let i = indexVal; i < $krUploadedThumbnails.length; i++) {
            $krUploadedThumbnails[i].removeEventListener('focus', reviewForm.prototype.onFocusEventHandleListener);
            $krUploadedThumbnails[i].setAttribute('data-image-index', i.toString());
            this.onFocusEventListenerThumbnailImage(i, element);
        }
        this.backImageUploadState= false;
    }

    removeImageFromThumbnailView = (removeSelector, indexval, element) => {
        let self = this;
        const handleEventListener = (ev)=>{
            ev.preventDefault();
            const updateSelector = element.querySelector('#kr-update-photo-button').classList[0];
            let $krUploadedThumbnails = element.querySelectorAll('.kr-uploaded-thumbnails');
            if(updateSelector!='kr-hide' && element.querySelector('.'+updateSelector)) {
                element.querySelector('.'+updateSelector).removeEventListener('click', reviewForm.prototype.updateImagehandleListener);
            }
            //remove image from thumbnail view list
            $krUploadedThumbnails[indexval].remove();
            element.querySelector('.kr-image-upload-events-container').remove();
            element.querySelector('.kr-image-caption-events-container').classList.add('kr-hide');
            reviewForm.prototype.allUploadedMedia.splice(indexval, 1);
            if(element.querySelector('.kr-images-section').childNodes.length<7) {
                self.showInputIfNotMaxNumberImageUploaded(element);
            }
            self.onRemoveThumbnailUpdateListener(indexval, element);
            $krUploadedThumbnails = element.querySelectorAll('.kr-uploaded-thumbnails');
            if($krUploadedThumbnails.length) {
                ($krUploadedThumbnails[0] as HTMLElement).focus();
            }
        }
        if(element.querySelector(removeSelector)) {
            element.querySelector(removeSelector).addEventListener('click', handleEventListener, true);
        }
    }

    editImageFromThumbnailView = (removeSelector, indexValue, element) => {
        let self = this,
            //writeReviewHeadingWrapperSelector = element.querySelector('.kr-writeReview-heading-wrapper'),
            //uploadImageHeaderSelector = element.querySelector('.kr-upload-image-header');
            uploadImageWrapper = element.querySelector('.kr-image-upload-wrapper') as HTMLLIElement;
        reviewForm.prototype.editImageHandleEventListener = (ev)=>{
            ev.preventDefault();
            self.backImageUploadState=false;
            self.editBeforeCancelOrUploadFlag =true;
            let media = reviewForm.prototype.allUploadedMedia[indexValue];
            // Show thumbnail for image files
            if (media && media.file.type.startsWith("image/")) {
                const reader = new FileReader();

                reader.readAsDataURL(media.file);
                reader.onload = () => {
                    let thumbnailElement = element.querySelector('.kr-upload-thumbnail .drop-zone__thumb') as HTMLElement;
                    thumbnailElement.style.backgroundImage = `url('${reader.result}')`;
                    self.showImageUploadForm(element);
                    self.showLabelOnEditImage(element);
                };
                let updateSelector = element.querySelector('#kr-update-photo-button').classList[0];
                if(updateSelector!='kr-hide' && element.querySelector('.'+updateSelector)) {
                    element.querySelector('.'+updateSelector).removeEventListener('click', reviewForm.prototype.updateImagehandleListener);
                }
                let captionTextArea = element.querySelector('.kr-image-caption-section textarea') as HTMLTextAreaElement,
                    updateImageBtn = element.querySelector('#kr-update-photo-button'),
                    randomStr = Utils.randomStr(20, '12345abcde'),
                    updateImgBtnClassSelector = 'kr-update-photo-button-'+JSON.stringify(indexValue)+'-'+randomStr;
                updateImageBtn.classList.value="";
                updateImageBtn.classList.add(updateImgBtnClassSelector);
                captionTextArea.value = media.caption;
                self.updateImageUpload(updateImgBtnClassSelector, media.file, indexValue, element);
                //writeReviewHeadingWrapperSelector.classList.add('kr-hide');
                uploadImageWrapper.classList.remove('kr-hide');
                self.updateImageCaptionValue(true, element);
            }
        }
        if(element.querySelector(removeSelector)) {
            element.querySelector(removeSelector).addEventListener('click', reviewForm.prototype.editImageHandleEventListener);
        }
    }

    updateImageUpload = (updateSelector, file, indexValue, element) => {
        let self = this;
        updateSelector = "."+updateSelector;
        reviewForm.prototype.updateImagehandleListener = (ev)=> {
            ev.preventDefault();
            let captionText = (element.querySelector('#kr-imageCaption') as HTMLTextAreaElement).value;
            let imageB64 = (element.querySelector('.kr-upload-thumbnail .drop-zone__thumb') as HTMLElement).style.backgroundImage;
            file = this.fileObjectOnChangeAction && file && file.name === this.fileObjectOnChangeAction.name ? file: this.fileObjectOnChangeAction
            if(file) {
                reviewForm.prototype.allUploadedMedia[indexValue] = {
                    file: file,
                    caption: captionText
                }
            } else {
                reviewForm.prototype.allUploadedMedia[indexValue]['caption'] = captionText
            }
            element.querySelector('.kr-image-caption-events-container .kr-image-caption-text').innerHTML = captionText;
            let thumbnailElement = element.querySelectorAll('.kr-uploaded-thumbnails');
            (thumbnailElement[indexValue].querySelector('.drop-zone__thumb') as HTMLElement).style.backgroundImage = imageB64;
            // this.updateImageCaptionValue();
            // const $maxCaptionError = element.querySelector('.kr-info-text kr-error-holder');
            // if(!$maxCaptionError){

            // }
            self.editImageUploadState=true;
            self.editBeforeCancelOrUploadFlag = false;
            self.changeImageAndBackFlag=false
            self.hideImageUploadForm(element);
            (thumbnailElement[indexValue] as HTMLElement).focus();
        }
        if(element.querySelector(updateSelector)) {
            element.querySelector(updateSelector).addEventListener('click', reviewForm.prototype.updateImagehandleListener);
        }

    }

    showLabelOnEditImage = (element) => {
        element.querySelector('.kr-edit-upload-image-heading').classList.remove('kr-hide');
        element.querySelector('.kr-upload-image-heading').classList.add('kr-hide');
        element.querySelector('#kr-update-photo-button').classList.remove('kr-hide');
        element.querySelector('#kr-add-photo-button').classList.add('kr-hide');
        (element.querySelector('.kr-back-to-formButton') as HTMLAnchorElement).focus();
    }

    getAllUploadMediaData(): Array<any> {
        return reviewForm.prototype.allUploadedMedia;
    }

    onlySpaces(str) {
        return /^\s*$/.test(str);
    }

}